// Import React
import React from "react";



// Export the reusable image option grid
export function PodDesignAiImageStyleOptionGrid({
    title,
    options,
    selectedValue,
    onSelect,
    disabled,
}) {


    // Return the grid UI
    return (

        <div className="podDesignAiImageOptionGrid">

            {/* This is the grid title */}
            <label className="podDesignAiImageOptionGrid__title">

                {title}

            </label>
            
            {/* This is the options grid */}
            <div className="podDesignAiImageOptionGrid__grid">

                {/* Loop through the options */}
                {options.map((option) => {

                    // Check if the option is selected
                    const isSelected = selectedValue === option.id;

                    // Return the option card
                    return (

                        <button
                            key={option.id}
                            className={`podDesignAiImageOptionGrid__card ${isSelected ? "podDesignAiImageOptionGrid__card--selected" : ""}`}
                            type="button"
                            onClick={() => onSelect(option.id)}
                            disabled={disabled}
                        >

                            <div className="podDesignAiImageOptionGrid__imageWrap">

                                {option.id === "none" ?

                                    <></>
                                
                                    :
                                   
                                    <img
                                        className={`podDesignAiImageOptionGrid__image ${option.id === "none" ? "podDesignAiImageOptionGrid__image--none" : ""}`}
                                        src={option.previewImage}
                                        alt={option.label}
                                    />

                                }
                           
                            </div>

                            {/* This is the option label */}
                            <span className="podDesignAiImageOptionGrid__label">

                                {option.label}

                            </span>

                        </button>

                    );

                })}

            </div>

        </div>
        
    );

}



// Export the reusable image option grid
export function PodDesignAiImageAspectRatioOptionGrid({
    title,
    options,
    selectedValue,
    onSelect,
    disabled,
}) {



    // Return the grid UI
    return (

        <div className="podDesignAiImageOptionGrid">

             {/* This is the grid title */}
            <label className="podDesignAiImageOptionGrid__title">

                {title}

            </label>
            
            {/* This is the options grid */}
            <div className="podDesignAiImageOptionGridAspectRatio__grid">

                {/* Loop through the options */}
                {options.map((option) => {

                    // Check if the option is selected
                    const isSelected = selectedValue === option.id;

                    // Return the option card
                    return (

                        <div
                            key={option.id}
                            className="podDesignAiImageOptionGridAspectRatio__card"    
                            onClick={() => onSelect(option.id)}
                        >

                            {/* This is the option aspect ratio */}
                            {option.aspectRatio && (

                                <div className="podDesignAiImageOptionGrid__aspectRatioPreview">

                                    <div
                                        className={`podDesignAiImageOptionGrid__aspectRatioShape podDesignAiImageOptionGrid__aspectRatioShape--${option.id}`}
                                        style={{
                                            aspectRatio: `${option?.aspectRatio?.width} / ${option?.aspectRatio?.height}`,
                                            backgroundColor: `${isSelected ? "var(--primary-color)"  : "var(--input-border)"}`,
                                            border: `2px solid ${isSelected ? "var(--primary-color)"  : "var(--input-border)"}`

                                        }}
                                    />

                                </div>

                            )}

                            {/* This is the option label
                            <span className="podDesignAiImageOptionGrid__label">

                                {option.label}

                            </span>
                            */}
                        </div>

                    );

                })}

            </div>

        </div>
        
    );

}